import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { WeekdayPosition } from 'src/@types/weekday';
const DAYS_IN_MONTH = 31;
export function useGetWeekdayPositionInMonth(date) {
    const { t } = useTranslation();
    const weekdayPositionInMonth = useMemo(() => {
        const weekdayPositionList = [
            {
                key: WeekdayPosition.First,
                text: t('mentorship.day_position_in_month.first')
            },
            {
                key: WeekdayPosition.Second,
                text: t('mentorship.day_position_in_month.second')
            },
            {
                key: WeekdayPosition.Third,
                text: t('mentorship.day_position_in_month.third')
            },
            {
                key: WeekdayPosition.Fourth,
                text: t('mentorship.day_position_in_month.fourth')
            },
            {
                key: WeekdayPosition.Fifth,
                text: t('mentorship.day_position_in_month.fifth')
            }
        ];
        const weekDay = date.getDay();
        const year = date.getFullYear();
        const month = date.getMonth();
        const occurrences = [];
        for (let day = 1; day <= DAYS_IN_MONTH; day++) {
            const d = new Date(year, month, day);
            if (d.getMonth() !== month)
                break;
            if (d.getDay() === weekDay) {
                occurrences.push(d);
            }
        }
        const index = occurrences.findIndex((d) => d.getDate() === date.getDate());
        const isTheLastDay = index === occurrences.length - 1;
        return {
            position: weekdayPositionList[index],
            isTheLastDay
        };
    }, [date, t]);
    return weekdayPositionInMonth;
}
